import moment from "moment";
import React from "react";
import { inject, observer } from "mobx-react";
import { injectIntl } from "react-intl";
import { Row, Col, Table, Button, Grid } from "react-bootstrap";
import { titles } from "./constants";
import DeleteButton from "../common_components/DeleteButton";

@inject("affiliationStore")
@observer
@injectIntl
export default class AffilationRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true
    };
    this.handleShow = this.handleShow.bind(this);
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    let { affiliationStore } = this.props;
    let sended;
    let now = moment();
    return (
      <tr>
        {titles.map((e, idx) => {
          if (e == "created_at")
            sended = moment(new Date(this.props.invitation[e].toString()));

          return (
            <td key={idx}>
              {e == "created_at"
                ? sended.fromNow()
                : e == "email"
                ? this.props.invitation[e]
                : this.props.intl.formatMessage({
                    id: this.props.invitation[e].toString()
                  })}
            </td>
          );
        })}
        <td>
          {moment.duration(now.diff(sended)).asDays() >= 0 ? (
            <div className="delete-container">
              <a
                className="btn"
                onClick={e => {
                  affiliationStore.removeObject(this.props.invitation["id"]);
                  let email = this.props.invitation["email"];
                  affiliationStore.formEmailChange(email);
                  affiliationStore.resendEmail(
                    this.props.invitation["id"],
                    this.props.invitation["role"]
                  );
                }}
              >
                <i className="fa fa-refresh" />
              </a>
            </div>
          ) : null}
        </td>
        <td>
          <div className="delete-container">
            <DeleteButton
              onDelete={() => {
                affiliationStore.removeObject(this.props.invitation["id"]);
              }}
            >
              Delete
            </DeleteButton>
          </div>
        </td>
      </tr>
    );
  }
}
